import "rxjs/add/operator/mergeMap";

import { Types, Creators } from "../reducer";

import * as firebase from 'firebase';

const updateRegistration = action => {
  // We already know where we want to go, so modify our object
  const dataToUpdate = {
    ...action.data,
    updated: Date.now()
  };

  return firebase
    .database()
    .ref(`registrations/${action.id}`)
    .update(dataToUpdate)
    .then(registration => Creators.registrationUpdated());
};

export default (action$, store) =>
  action$.ofType(Types.UPDATE_REGISTRATION).mergeMap(updateRegistration);



// WEBPACK FOOTER //
// ./src/registration/epics/updateRegistration.js